








































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import PartnershipSteps from '@ui/AudienceSetWizard/PartnershipStep/PartnershipSteps'

settings =
  name: 'PartnershipDemographicsForm'

  vue:
    props: ['form']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      PartnershipSteps,
    }

    data: ->
      demographics:
        gender:
          female: ''
          male: ''
        age:
          '<18': ''
          '18-24': ''
          '25-34': ''
          '35-44': ''
          '45-54': ''
          '55+': ''
        ethnicity:
          african: ''
          asian: ''
          hawaiian: ''
          hispanic: ''
          native_American: ''
          white: ''
          multiple: ''
          other: ''

      state1: ''

    methods:
      percentageOptions: (_, cb) ->
        cb([...Array(100).keys()].map((v) -> ({ value: String(v + 1) })))

export default VueOptions.vue settings
